import { Colors } from '../../consts/Colors.js';
import FONTS from '../../consts/Fonts.js';
import { tags } from '../../consts/Tags.js';
import ButtonRounded from '../../prefabs/global/buttons/ButtonRounded.js';
import PopUpBlue from '../../prefabs/global/popup/PopUpBlue.js';
import SoundManager from '../../prefabs/SoundManager.js';
import AbstractScene from '../AbstractScene.js';

export default class DebutChapitre1 extends AbstractScene {

    constructor() {
        super({
            key: "DebutChapitre1"
        })
    }

    preload() {
        this._preload();

        
    }

    init(data){
        this._init(data);   

        this.soundManager = new SoundManager();
        this.soundManager.stopAllLoops()
        this.soundManager.playAudio('MemoriesOfParis');
    }

    create() {
        // Ajout fond
        let background = this.add.image(0, 0, 'Chapitre1_transition_background').setOrigin(0);

        // Ajout num chapitre
        let numChapitre = this.add.text(this.width/2, 124, 'CHAPITRE 1',{
            fontSize: '18px',
            fontFamily: FONTS.Inter18Light,
            color: Colors.Text.White,
            letterSpacing:5
        }).setOrigin(0.5, 0)
        numChapitre.setAlpha(0)

        // Ajout titre
        let titre1 = this.add.image(this.width/2, 177, 'Chapitre1_transition_titre').setOrigin(0.5, 0)
        titre1.setAlpha(0)

        // Ajout transitions

        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        this.tweens.add({
            targets: rect,
            alpha: 0,
            duration: 1000,
            onComplete: () => {
                rect.destroy();
                
            }
        })

        this.tweens.add({
            targets: numChapitre,
            alpha: 1,
            delay: 200,
            duration: 200,
        })

        titre1.x -=50
        this.tweens.add({
            targets: titre1,
            alpha: 1,
            x: titre1.x + 50,
            delay: 400,
            duration: 400,
        })


        this.time.addEvent({
            delay: 1000,
            callback: () => {
                this.addPopUp()
            }
        })

    }

    addPopUp(){

        this.popupAide = new PopUpBlue(this, this.width/2, 808, 950, 455)
        this.popupAide.depth = 1001

        const txt ="Direction le bureau parisien de Leïla Cercis, dernier endroit où elle a été vue. Si elle a réellement découvert quelque chose de compromettant, elle a peut-être laissé des indices derrière elle.\n\nJe vais devoir fouiller les lieux avec attention : chaque document, chaque note et chaque objet peut me rapprocher de la vérité. Je ne m'attends pas à une enquête ordinaire. Entre fausses pistes, secrets bien gardés et révélations troublantes, faire toute la lumière sur cette affaire ne sera pas de tout repos."
        let textElmt = this.add.rexTagText(0, 0, txt, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '24px',
            color: Colors.Text.White,
            align: 'left',
            wordWrap: { width: 832 },
            lineSpacing: 4,
            tags: tags
        }).setOrigin(0.5, 0)

        this.popupAide.addElementToBody(textElmt, 40)

        let button = new ButtonRounded(this, 0, 0, {
            text: "Démarrer le chapitre 1",
            color: Colors.Elmt.White,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
            borderOpacity: 0.5,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue
        })
        this.popupAide.addButtonToBody(button);
        button.setClickFunction( () => {
            this.animOut()
        })

        this.popupAide.animIn()
    }

    animOut(){
        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        rect.setAlpha(0)
        rect.depth = 1002
        this.tweens.add({
            targets: rect,
            alpha: 1,
            duration: 1000,
            onComplete: () => {
                this.scene.start("Chapitre1")
            }
        })
    }
}